import React from "react";
const NotFound: React.FC = () => (
    <div className="main">
        <div className="card">Страница не найдена</div>
    </div>
);
export default NotFound;
